import "./jquery-global.js";
import $ from "jquery";
import "bootstrap";

import "./custom.js";

import "./modules/module-hero/module-hero.js";
import "./modules/module-event-swiper/module-event-swiper.js";
import "./modules/module-articleimage-galleryswiper/module-articleimage-galleryswiper.js";


